import {
    Card,
    Flex,
    Radio,
    Space
} from "antd";
import React, {useCallback, useState} from "react";
import {aiChainPrompt} from "../../Prompt";
import {ModelsMenu} from "../../components/ModelsMenu";
import {LanguagesGroup} from "../../components/LanguagesGroup";
import {CountriesAutoComplete} from "../../components/CountriesAutoComplete";
import {ListResults} from "../../components/ListResults";
import {GenButton} from "../../components/GenButton";
import {generatePersonNamePrompt} from "../ToolsPrompts";

export const PersonNameGenerator = (props: {
    onItemClick?: (item: any) => void
}) => {
    const [sex, setSex] = useState("male");
    const [origin, setOrigin] = useState("United States");
    const [languages, setLanguages] = useState(["Russian"]);
    const [names, setNames] = useState([]);
    const [switchLangs, setSwitchLangs] = useState<string[]>([]);
    const [height, setHeight] = useState(0);

    const elementRef = useCallback((node: any) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setHeight(node.getBoundingClientRect().height);
        });
        resizeObserver.observe(node);
    }, []);

    return (
        <Flex gap={16} style={{width: "100%"}}>
            <Flex vertical={true} gap={10} style={{height: "100%", width: 300}} ref={elementRef}>
                <ModelsMenu/>
                <Card
                    title={"Sex"}
                >
                    <Space direction={'vertical'}>
                        <Radio
                            checked={sex == "male"}
                            onChange={(e) => {
                                if (e.target.checked) setSex("male")
                            }}>Male</Radio>
                        <Radio
                            checked={sex == "female"}
                            onChange={(e) => {
                                if (e.target.checked) setSex("female")
                            }}>Female</Radio>
                    </Space>
                </Card>
                <Card title={"Origin"}>
                    <CountriesAutoComplete
                        selectedOrigin={origin}
                        onOriginSelected={setOrigin}
                    />
                </Card>
                <Card title={"Languages"}>
                    <LanguagesGroup
                        languages={languages}
                        onChange={setLanguages}
                    />
                </Card>
                <GenButton
                    style={{width: "100%"}}
                    type={'primary'}
                    actions={[{
                        key: "1",
                        title: "Generate",
                        action: async (model: string, projectId: string) =>
                            aiChainPrompt({
                                projectId: projectId ?? '',
                                prompt: generatePersonNamePrompt(
                                    {
                                        sex: sex,
                                        translations: languages,
                                        country: origin
                                    }
                                ),
                                model: model,
                                type: "json"
                            }).then((response) => {
                                setNames(response.data)
                                setSwitchLangs(languages)
                            }).catch((e) => {
                                console.log(e)
                            })
                    }]}/>
            </Flex>
            <ListResults
                items={names}
                onItemClick={props.onItemClick}
                height={height}
                languages={switchLangs}
            />
        </Flex>
    );
}